import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"
import { Button } from "reactstrap"
import "react-multi-date-picker/styles/backgrounds/bg-dark.css"

export default class Reports extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: '',
            filters: {
                comId: 0,
                type: -1,
                fasl:0,
                startDate: null,
                startDateM: null,
                endDate: null,
                endDateM: null,
                taxId: null,
                inty: 0,
                statusTax: 0,
                serial: 0
            }

        };

    }
    setTypeRec(v) {
        this.state.filters.type = v;
        this.setState({ data: this.state.data });
    }
    setinty(v) {
        this.state.filters.inty = v;
        this.setState({ data: this.state.data });
    }
    setStatusTax(v) {
        this.state.filters.statusTax = v;
        this.setState({ data: this.state.data });
    }
    setTypeFasl(v) {
        this.state.filters.fasl = v;
        this.setState({ data: this.state.data });
    }
    setStartDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.startDate = data;
            this.state.filters.startDateM = v.toDate();
        }
        else {
            this.state.filters.startDate = null;
            this.state.filters.startDateM = null;
        }

        this.setState({ data: this.state.data });
    }
    setEndDate(v) {
        if (v != null) {
            let data = v.toString();
            this.state.filters.endDate = data;
            this.state.filters.endDateM = v.toDate();
        }
        else {
            this.state.filters.endDate = null;
            this.state.filters.endDateM = null;
        }

        this.setState({ data: this.state.data });
    }


    recoveryData(e) {
        this.state.phrase = "";
        this.state.filters.comId = 0;
        this.state.filters.fasl = 0;
        this.state.filters.type = -1;
        this.state.filters.startDateM = null;
        this.state.filters.startDate = null;
        this.state.filters.endDateM = null;
        this.state.filters.endDate = null;
        this.state.filters.inty = 0;
        this.state.filters.taxId = null;
        this.state.filters.statusTax = 0;
        this.state.filters.serial = 0;
        this.refreshData(e);
    }

    loadPersonsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getcustomer/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.fullName
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };


    componentDidMount() {
        this.refreshData();
    }
    async getexcelall() {
        this.setState({ loading: true });

        this.httpPost("api/v1/report/allexcel", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const linkSource = `data:application/vnd.ms-excel;base64,${data.bs64}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "invoic.xlsx";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.setState({ loading: false });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            })
    }

    async getexceldetail() {
        this.setState({ loading: true });

        this.httpPost("api/v1/report/detailexcel", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const linkSource = `data:application/vnd.ms-excel;base64,${data.bs64}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "invoic.xlsx";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.setState({ loading: false });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            })
    }
    
    async getexceljame() {
        this.setState({ loading: true });

        this.httpPost("api/v1/report/jameexcel", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const linkSource = `data:application/vnd.ms-excel;base64,${data.bs64}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "invoic.xlsx";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.setState({ loading: false });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            })
    }
    renderForm() {
        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-head">
                            <div class="card card-bordered card-preview">
                                <div class="card-inner">
                                    <div class="row g-6">
                                        <div className="col-lg-2">
                                            <a onClick={e => this.getexceldetail(e)} className="btn btn-warning"><em class="icon ni ni-file-xls"></em><span>گزارش صورت حساب جزیی</span></a>

                                        </div>
                                        <div className="col-lg-2">
                                            <a onClick={e => this.getexcelall(e)} className="btn btn-secondary"><em class="icon ni ni-file-xls"></em><span>گزارش صورت حساب کلی</span></a>

                                        </div>
                                        <div className="col-lg-2">
                                            <a onClick={e => this.getexceljame(e)} className="btn btn-info"><em class="icon ni ni-file-xls"></em><span>خروجی فایل جامع تجارت</span></a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nk-block">
                        <div className="card card-bordered card-stretch">
                            <div className="card-inner-group">
                                <div className="card-inner position-relative card-tools-toggle">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>

                                        <div id="accordion" class="accordion" style={{ width: '100%' }}>
                                            <div class="accordion-item">
                                                <a href="#" class="accordion-head" data-bs-toggle="collapse" data-bs-target="#accordion-item-1">
                                                    <h6 class="title">جستجوی پیشرفته</h6>

                                                </a>
                                                <div class="accordion-body collapse" id="accordion-item-1" data-bs-parent="#accordion">
                                                    <div class="accordion-inner">
                                                        <div className=""></div>
                                                        <div className="row g-gs">
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">انتخاب مشتری</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync

                                                                            defaultValue={this.state.filters.comId > 0 ? [{ value: this.state.filters.comId, label: this.state.filters.coTitle }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب مشتری"
                                                                            defaultOptions
                                                                            isSearchable
                                                                            loadOptions={this.loadPersonsOptions}
                                                                            onChange={e => this.state.filters.comId = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="col-lg-2">
                                                                <div className="form-group">
                                                                    <label className="form-label">تاریخ شروع</label>
                                                                    <div className="form-control-wrap">
                                                                        <DatePicker
                                                                          
                                                                            value={this.state.filters.startDateM}
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "34px",
                                                                                fontSize: "14px",
                                                                                padding: "3px 10px",


                                                                            }}

                                                                            onChange={e => this.setStartDate(e)}
                                                                            calendar={persian}
                                                                            locale={persian_fa} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-2">
                                                                <div className="form-group">
                                                                    <label className="form-label">تاریخ پایان</label>
                                                                    <div className="form-control-wrap">
                                                                        <DatePicker
                                                                     
                                                                            value={this.state.filters.endDateM}
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "34px",
                                                                                fontSize: "14px",
                                                                                padding: "3px 10px",


                                                                            }}

                                                                            onChange={e => this.setEndDate(e)}
                                                                            calendar={persian}
                                                                            locale={persian_fa} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">نوع صورت حساب</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" type="text" defaultValue={this.state.filters.inty} onChange={e => this.setinty(parseInt(e.target.value))}>
                                                                            <option value="0">انتخاب نوع صورت حساب</option>
                                                                            <option value="1">اول</option>
                                                                            <option value="2">دوم</option>
                                                                            <option value="3">سوم</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">شماره منحصر به فرد مالیاتی</label>
                                                                    <div className="form-control-wrap">
                                                                        <input className="form-control" type="text" defaultValue={this.state.filters.taxId} onChange={e => this.state.filters.taxId = e.target.value} />

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">سریال فاکتور</label>
                                                                    <div className="form-control-wrap">
                                                                        <input className="form-control" type="text" defaultValue={this.state.filters.serial} onChange={e => this.state.filters.serial = parseInt(e.target.value)} />

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">وضعیت صورت حساب</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" type="text" defaultValue={this.state.filters.statusTax} onChange={e => this.setStatusTax(parseInt(e.target.value))}>
                                                                            <option value="0">انتخاب وضعیت صورت حساب</option>
                                                                            <option value="1">تایید شده</option>
                                                                            <option value="2">باطل شده</option>
                                                                            <option value="3">عدم نیاز به واکنش</option>
                                                                            <option value="4">رد شده</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">نوع فاکتور</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" type="text" defaultValue={this.state.filters.type} onChange={e => this.setTypeRec(parseInt(e.target.value))}>
                                                                            <option value="0">انتخاب وضعیت</option>
                                                                            <option value="1">فروش</option>
                                                                            <option value="3">طلاجواهر و پلاتین</option>
                                                                            <option value="2">فروش ارز</option>
                                                                            <option value="4">پیمانکاری</option>
                                                                            <option value="5">قبوض خدماتی</option>
                                                                            <option value="6">بلیط هواپیما</option>
                                                                            <option value="7">صادرات</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">نوع فصل</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" type="text" defaultValue={this.state.filters.fasl} onChange={e => this.setTypeFasl(parseInt(e.target.value))}>
                                                                            <option value="0">انتخاب وضعیت</option>
                                                                            <option value="1">بهار</option>
                                                                            <option value="2">تابستان</option>
                                                                            <option value="3">پاییز</option>
                                                                            <option value="4">زمستان</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">برای فیلتر کردن دیکه جستجو را بزنید</label>
                                                                    <div className="form-control-wrap">
                                                                        <div className="btn-wrap">
                                                                            <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-success hand"><em class="icon ni ni-search"></em> جستجوی اطلاعات </button></span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4">
                                                                <div className="form-group">
                                                                    <label className="form-label">بازیابی اطلاعات</label>
                                                                    <div className="form-control-wrap">
                                                                        <div className="btn-wrap">
                                                                            <span className="d-none d-md-block">
                                                                                <Button onClick={e => this.recoveryData(e)} className="btn-dim" outline color="info"><em class="icon ni ni-search"></em> بازیابی اطلاعات  </Button>

                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>




                                    </form>
                                </div>
                                
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head" style={{ backgroundColor: "#16498a" }}>
                                            <div className="nk-tb-col"><span className="sub-text text-center text-white">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center text-white">الگو</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center text-white">موضوع</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center text-white">نوع</span></div>
                                            <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center text-white">سریال</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center text-white">شماره منحصربفرد مالیاتی</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">شماره مالیاتی مرجع</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">تاریخ</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">تاریخ ثبت در سامانه</span></div>

                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">طرف حساب</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">مبلغ کل</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">وضعیت صورت حساب</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">نحوه تسویه</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center text-white">وضعیت</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{record.inpString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{record.insString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center tb-lead">{record.intyString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-sm">
                                                    <span className="sub-text text-center tb-lead">{record.inno}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center tb-lead">{record.taxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center tb-lead">{record.irtaxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.indatimPersian}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.sendTax}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.customerName}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{this.money(record.tbill)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center tb-lead">{record.statusTax}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    {record.setm === 1 && <span className="sub-text text-center tb-lead">نقدی</span>}
                                                    {record.setm === 2 && <span className="sub-text text-center tb-lead">نسیه</span>}
                                                    {record.setm === 3 && <span className="sub-text text-center tb-lead">نقد/نسیه</span>}
                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">
                                                    {record.status === 1 && <span class="tb-status text-info">{record.statusString}</span>}
                                                    {record.status === 2 && <span class="tb-status text-warning">{record.statusString}</span>}
                                                    {record.status === 3 && <span class="tb-status text-danger">{record.statusString}</span>}
                                                    {record.status === 4 && <span class="tb-status text-success">{record.statusString}</span>}
                                                </div>
                                        
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.createPaging()}

                                <br />
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">

                                            <div className="form-inline flex-nowrap">
                                                <div className="row g-3">
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع بدون احتساب</label>
                                                        <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.sumNoTax} />

                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع مالیات</label>
                                                            <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.tax} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group">
                                                            <label className="form-label">جمع کلی با احتساب مالیات</label>
                                                        <div className="form-control-wrap">
                                                            <input type="text" className="form-control" type="text" value={this.state.data.sumAll} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
                {!this.isBlank(this.state.Id_to_remove) &&
                    <div className="modalBg">
                        <div className="modalInner">
                            <p>آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                            <button className="btn btn-danger" onClick={e => { this.remove(); }}>بله</button>
                            <button className="btn btn-primary mr-r-10" onClick={e => { this.setState({ id_to_remove: null }); }}>انصراف</button>
                        </div>
                    </div>
                }
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}